import { createLucideIcon } from "lucide-react";

export const CheckMark = createLucideIcon(
    "CheckMark",
    [
        [
            "path",
            {
                d: "M20 6 9 17l-5-5",
                key: "1gmf2c",
            },
        ],
    ],
);
